import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatSessionUpdatedEvent} from '../types/events'
import {NinchatState} from 'api/types'

export const sessionUpdated: CaseReducer<NinchatState> = (state, action) => {
    const event = action.payload as NinchatSessionUpdatedEvent

    state.session_realms_permissions = event.session_realms_permissions
}
